import { WbTabsList, WbTabsTrigger } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { useEditorPageContext } from '../context/useEditorPageContext';

import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import CodeIcon from '@material-ui/icons/Code';

/**
 * Toggle between Preview (custom view) and Raw YAML modes.
 *
 * The WbTabsListContext is provided by the parent EditorCard, which wraps
 * the entire WbDockableGroup. This makes the context a common ancestor of
 * both this toggle (in the panel header) and the WbTabsContent panels
 * in DescriptorCard (in the panel body), enabling proper ARIA wiring.
 */
export const DescriptorViewToggle: FC = () => {
  const { showSwitchDescriptorViewMode } = useEditorPageContext();

  if (!showSwitchDescriptorViewMode) return null;

  return (
    <WbTabsList aria-label="Descriptor view mode">
      <WbTabsTrigger
        value="customView"
        title="Preview"
        icon={<VisibilityOutlinedIcon style={{ fontSize: 16 }} />}
      />
      <WbTabsTrigger
        value="yaml"
        title="Raw YAML"
        icon={<CodeIcon style={{ fontSize: 16 }} />}
      />
    </WbTabsList>
  );
};
